import { render, staticRenderFns } from "./LinkTextIcon.vue?vue&type=template&id=63f4150e&scoped=true"
import script from "./LinkTextIcon.vue?vue&type=script&lang=js"
export * from "./LinkTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f4150e",
  null
  
)

export default component.exports